import { CHANGE, } from '../reducers/search';

function changeType(text: string) {
    return {
        type: CHANGE,
        payload: text
    };
}

export function change(text: string) {
    return (dispatch: any) => {
        return new Promise<void>((ok, error): void => {
            dispatch(changeType(text));
            ok();
        });
    }
}
